import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';

const glossary = {
    "for": "A type of loop used when we know how many times we want to repeat a block of code.",
    "if": "Used for decision making and will run the body of indented code below only if the statement is true.",
    "elif": "Used with an if statement and will only run its indented body of code if the if statement is false and the condition for the elif statement is true. It can be used when there are multiple possibilities for something and can be used as many times as needed.",
    "else": "Used with an if statement and will only run its indented body of code if the if statement or any elif statements are false.",
    "[ ]": "A list is a data structure that is a mutable ordered sequence of elements. Each element or value that is inside of a list is called an item. Lists are defined by having values separated by commas between square brackets.",
    "( )": "Used for ordering operations. Also used to define tuples.",
    "in": "Used to iterate through a sequence in a for loop. Also used to check if a value is present in a sequence.",
    "and": "Logical operator, which will result in True only if both of the operands are True.",
    "or": "Logical operator, which will result in True if any of the operands is True.",
    "not": "Used to invert the truth value.",
    "from": "Used during import statements to load submodules.",
    "def": "Used to define a user-defined function",
    "import": "Used to import modules.",
    "while": "Repeatedly executes the indented body of code while a condition is true.",
    "True": "Truth value that can be he result of comparisons or logical operations.",
    "False": "Truth value that can be he result of comparisons or logical operations.",
    "range": "A built-in Python function that returns a sequence of numbers, starting from 0 by default, and increments by 1 (by default), and stops before a specified number. For example, range(4),  range(0, 4) and range(0, 4, 1) all return the sequence 0, 1, 2, 3.",
    "m": "Denotes the 64 pixel imagiCharm matrix.",
    "on": "Used to turn on a pixel. Results in the same output as using the color W (white).",
    "off": "Used to turn off a pixel. Results in the same output as using black color.",
    "row": "A variable that can be given a value by the user.",
    "col": "A variable that can be given a value by the user.",
    ':': "colon",
    ",": "comma",
    "R": "Used to color a pixel red. Same as using (255,0,0).",
    "G": "Used to color a pixel green. Same as using (0,255,0).",
    "B": "Used to color a pixel blue. Same as using (0,0,255).",
    "A": "Used to color a pixel aqua. Same as using (0,255,255).",
    "Y": "Used to color a pixel yellow. Same as using (255,255,0).",
    "O": "Used to color a pixel orange. Same as using (255,165,0).",
    "M": "Used to color a pixel fuchsia. Same as using (255,0,255)",
    "P": "Used to color a pixel purple. Same as using (148,0,211).",
    "W": "Used to color a pixel white. Same as using (255,255,255)."
}



const HtmlTooltip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: '#000000',
        color: 'rgb(255,255,255)',
        maxWidth: 300,
        fontSize: theme.typography.pxToRem(12),
        border: `1px solid black`,
    },
}))(Tooltip);


export default class KeywordButton extends Component {

    getExplanation = () => {

        return glossary[this.props.children]

    }


    _onClick = () => {

        this.props.onClick(this.props.button_id)
    }

    render() {
        return (

            <HtmlTooltip
                title={
                    <React.Fragment>
                        <Typography color="inherit">{this.props.children}</Typography>
                        {this.getExplanation()}
                    </React.Fragment>
                }
                placement="top"
            >
                <button onClick={this._onClick} style={{
                    border: `2px solid ${this.props.borderColor}`,
                    boxSizing: "border-box",
                    borderRadius: "20px",
                    backgroundColor: "black",
                    color: this.props.color,
                    outline: 'none',
                    fontSize: "17px",
                    paddingLeft: '10px',
                    paddingRight: "10px",
                    marginRight: "0.5%"
                }}>{this.props.children}</button>

            </HtmlTooltip>

        )
    }
}